window.FoxTheme = window.FoxTheme || {};
FoxTheme.config = {
  hasLocalStorage: false,
  mqlMobile: false,
  mqlTablet: false,
  mediaQueryMobile: 'screen and (max-width: 767px)',
  mediaQueryTablet: 'screen and (max-width: 1023px)',
  motionReduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  disableAnimations: !FoxTheme.settings.enableAnimation,
  isTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,
  isRTL: document.documentElement.getAttribute('dir') === 'rtl',
  isIOS: /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1),
};
console.log(
  '%c' +
    window.FoxTheme.settings.themeName +
    ' theme (v' +
    window.FoxTheme.settings.themeVersion +
    ') by Foxecom | Learn more https://foxecom.com/products/sleek-shopify-theme',
  'font-size: 14px; color: #FF5C00;'
);
(function () {
  // Detect browser has support local storage.
  try {
    const key = 'sleek:test';
    window.localStorage.setItem(key, 'test');
    window.localStorage.removeItem(key);
    FoxTheme.config.hasLocalStorage = true;
  } catch (err) {}

  FoxTheme.DOMready = function (callback) {
    document.readyState != 'loading' ? callback() : document.addEventListener('DOMContentLoaded', callback);
  };

  FoxTheme.a11y = {
    trapFocusHandlers: {},
    getFocusableElements: (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    },
    trapFocus: (container, elementToFocus = container) => {
      // A missing target (a re-rendered row, an empty cart) must not throw: it would abort the rest of the caller
      if (!container) return;
      elementToFocus = elementToFocus || container;

      FoxTheme.a11y.removeTrapFocus();

      FoxTheme.a11y.trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key

        // Read on each Tab: what can take focus changes while the container is open (an empty cart hides its form).
        var elements = FoxTheme.a11y.getFocusableElements(container).filter(function (element) {
          return (
            element.tabIndex >= 0 &&
            element.getClientRects().length > 0 &&
            getComputedStyle(element).visibility !== 'hidden' &&
            !element.closest('[inert]')
          );
        });
        var first = elements[0];
        var last = elements[elements.length - 1];
        if (!first) return;

        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };

      document.addEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);

      elementToFocus.focus();

      if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    },
    removeTrapFocus: (elementToFocus = null) => {
      document.removeEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);

      if (elementToFocus) elementToFocus.focus();
    },
  };

  FoxTheme.utils = {
    throttle: (callback) => {
      let requestId = null,
        lastArgs;
      const later = (context) => () => {
        requestId = null;
        callback.apply(context, lastArgs);
      };
      const throttled = (...args) => {
        lastArgs = args;
        if (requestId === null) {
          requestId = requestAnimationFrame(later(this));
        }
      };
      throttled.cancel = () => {
        cancelAnimationFrame(requestId);
        requestId = null;
      };
      return throttled;
    },
    setScrollbarWidth: () => {
      const scrollbarWidth = `${Math.max(window.innerWidth - document.body.clientWidth, 0)}px`;
      // Keep it current on resize. A write restyles the whole page, so only when it changes.
      if (document.documentElement.style.getPropertyValue('--scrollbar-width') !== scrollbarWidth) {
        document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth);
      }
    },
    // Runs once in the element's next frame, after layout and before paint: reading sizes there forces no reflow.
    onceLaidOut: (element, callback) => {
      const observer = new ResizeObserver(() => {
        observer.disconnect();
        callback();
      });
      observer.observe(element);
      return observer;
    },
    waitForEvent: (element, eventName) => {
      return new Promise((resolve) => {
        // Event handler that checks if the event target is the expected element
        const eventHandler = (event) => {
          if (event.target === element) {
            element.removeEventListener(eventName, eventHandler); // Clean up listener
            resolve(event); // Resolve the promise with the event
          }
        };

        // Attach the event handler to the element
        element.addEventListener(eventName, eventHandler);
      });
    },
    queryDomNodes: (selectors = {}, context = document) => {
      const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
        const findOne = typeof selector === 'string';
        const queryMethod = findOne ? 'querySelector' : 'querySelectorAll';
        const sl = findOne ? selector : selector[0];

        acc[name] = context && context[queryMethod](sl);
        if (!findOne && acc[name]) {
          acc[name] = [...acc[name]];
        }
        return acc;
      }, {});
      return domNodes;
    },
    addEventDelegate: ({ context = document.documentElement, event = 'click', selector, handler, capture = false }) => {
      const listener = function (e) {
        // loop parent nodes from the target to the delegation node
        for (let target = e.target; target && target !== this; target = target.parentNode) {
          if (target.matches(selector)) {
            handler.call(target, e, target);
            break;
          }
        }
      };
      context.addEventListener(event, listener, capture);
      return () => {
        context.removeEventListener(event, listener, capture);
      };
    },
    getSectionId: (element) => {
      if (element.hasAttribute('data-section-id')) {
        return element.dataset.sectionId;
      } else {
        if (!element.classList.contains('shopify-section')) {
          element = element.closest('.shopify-section');
        }
        return element.id.replace('shopify-section-', '');
      }
    },
    debounce: (fn, wait) => {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    },
    fetchConfig: (type = 'json', method = 'POST') => {
      return {
        method,
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
      };
    },
    /**
     * Store key-value pair with expiration time in localStorage
     * Use storage instead of cookie to make it work properly on Safari IOS (in iframe).
     */
    setStorage(key, value, expiryInDays) {
      if (!FoxTheme.config.hasLocalStorage) return;

      const now = new Date();
      const item = {
        value: value,
        expiry: now.getTime() + expiryInDays * 86400000,
      };
      window.localStorage.setItem(key, JSON.stringify(item));
    },
    getStorage(key) {
      if (!FoxTheme.config.hasLocalStorage) return null;

      const itemStr = window.localStorage.getItem(key);
      // If the item doesn't exist, return null.
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      const now = new Date();
      // Compare the expiry time of the item with the current time.
      if (now.getTime() > item.expiry) {
        // If the item has expired, remove it from storage and return null.
        window.localStorage.removeItem(key);
        return null;
      }
      return item.value;
    },
    postLink: (path, options) => {
      options = options || {};
      const method = options['method'] || 'post';
      const params = options['parameters'] || {};

      const form = document.createElement('form');
      form.setAttribute('method', method);
      form.setAttribute('action', path);

      for (const key in params) {
        for (const index in params[key]) {
          for (const key2 in params[key][index]) {
            const hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', `${key}[${index}][${key2}]`);
            hiddenField.setAttribute('value', params[key][index][key2]);
            form.appendChild(hiddenField);
          }
        }
      }
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
    imageReady: (imageOrArray) => {
      if (!imageOrArray) {
        return Promise.resolve();
      }
      imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
      return Promise.all(
        imageOrArray.map((image) => {
          return new Promise((resolve) => {
            if ((image.tagName === 'IMG' && image.complete) || !image.offsetParent) {
              resolve();
            } else {
              image.onload = () => resolve();
            }
          });
        })
      );
    },
    displayedMedia: (media) => {
      return Array.from(media).find((item) => {
        const style = window.getComputedStyle(item);
        return style.display !== 'none';
      });
    },
    getGridColumnGap: (container) => {
      const gapByDevice = {};
      const gapCSSVariables = {
        desktop: '--column-gap',
        tabletLarge: '--column-gap-tablet-large',
        tablet: '--column-gap-tablet',
        mobile: '--column-gap-mobile',
      };

      const computedStyles = window.getComputedStyle(container);

      for (const [device, cssVar] of Object.entries(gapCSSVariables)) {
        const rawValue = computedStyles.getPropertyValue(cssVar).trim();
        const match = rawValue.match(/^(\d*\.?\d+)(px|rem)$/);

        let numericGap = 0;
        if (match) {
          const [originalValue, numberStr, unit] = match;
          numericGap = unit === 'rem' ? parseFloat(numberStr) * 10 : parseFloat(numberStr);
        }

        gapByDevice[device] = numericGap;
      }

      return gapByDevice;
    },
  };

  FoxTheme.pubsub = {
    PUB_SUB_EVENTS: {
      cartUpdate: 'cart-update',
      quantityUpdate: 'quantity-update',
      quantityRules: 'quantity-rules',
      quantityBoundries: 'quantity-boundries',
      variantChange: 'variant-change',
      cartError: 'cart-error',
      facetUpdate: 'facet-update',
      optionValueSelectionChange: 'option-value-selection-change',
    },
    subscribers: {},
    subscribe: (eventName, callback) => {
      if (FoxTheme.pubsub.subscribers[eventName] === undefined) {
        FoxTheme.pubsub.subscribers[eventName] = [];
      }

      FoxTheme.pubsub.subscribers[eventName] = [...FoxTheme.pubsub.subscribers[eventName], callback];

      return function unsubscribe() {
        FoxTheme.pubsub.subscribers[eventName] = FoxTheme.pubsub.subscribers[eventName].filter((cb) => {
          return cb !== callback;
        });
      };
    },

    publish: (eventName, data) => {
      if (FoxTheme.pubsub.subscribers[eventName]) {
        FoxTheme.pubsub.subscribers[eventName].forEach((callback) => {
          // One failing subscriber must not stop the others, nor the code that published
          try {
            callback(data);
          } catch (error) {
            console.error(`[FoxTheme.pubsub] a "${eventName}" subscriber failed:`, error);
          }
        });
      }
    },
  };

  FoxTheme.focusVisiblePolyfill = function () {
    const navKeys = [
      'ARROWUP',
      'ARROWDOWN',
      'ARROWLEFT',
      'ARROWRIGHT',
      'TAB',
      'ENTER',
      'SPACE',
      'ESCAPE',
      'HOME',
      'END',
      'PAGEUP',
      'PAGEDOWN',
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
      if (navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });

    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });

    window.addEventListener(
      'focus',
      () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');
      },
      true
    );
  };

  FoxTheme.Carousel = (function () {
    /**
     * Swiper wrapper. The optional 4th argument wires the carousel kit (snippets/carousel-controls.liquid):
     * - controls: element holding [data-carousel-prev|next|dots|fraction]; fills `navigation` and
     *   `pagination` unless `options` sets them.
     * - fraction: 'pages' renders "1 of 5" pages into [data-carousel-fraction] (one page = the
     *   whole slides in view). Not for `loop` (use `rewind`), and not with autoplay: the fraction is a
     *   live region.
     * - fadePartial: toggles .is-partial on slides that are not fully inside the container. Not with
     *   `centeredSlides` or `slidesOffsetBefore`.
     * - clip: an ancestor that clips a container bleeding past it (overflow: hidden); fadePartial and the focus
     *   sync count a slide as inside against the part of the container it leaves visible. Horizontal only.
     * Any kit also keeps keyboard focus in sync: Tab into a slide out of view slides to it, and the native
     * scroll the browser applies to reveal the focused element (under Swiper's transform) is reset to 0 on
     * the container and on the clip.
     */
    class Carousel {
      constructor(container, options, modules = null, kit = null) {
        this.container = container;
        this.kit = kit || {};
        this.hasKit = Boolean(kit);
        let defaultModules = [
          FoxTheme.Swiper.Navigation,
          FoxTheme.Swiper.Pagination,
          FoxTheme.Swiper.Keyboard,
          FoxTheme.Swiper.Mousewheel,
        ];
        if (modules) {
          defaultModules = defaultModules.concat(modules);
        }

        this.options = {
          modules: defaultModules,
          // Swiper's preload downloads every image in the slider on init, even with loading="lazy".
          preloadImages: false,
          // speed: 300,
          ...options,
          // ...(FoxTheme.config.disableAnimations ? { speed: 0 } : {}),
          ...(FoxTheme.config.motionReduced ? { autoplay: false } : {}),
        };

        if (kit) this.applyKit();
      }

      init() {
        this.slider = new FoxTheme.Swiper.Swiper(this.container, this.options);
        this.ignoreHarmlessResize();
        this.watchUpcomingImages();
        if (this.fractionEl) this.watch(this.updateFraction, 'slideChange snapIndexChange snapGridLengthChange');
        if (this.kit.fadePartial) this.watch(this.updatePartial, 'setTranslate resize');
        if (this.hasKit) this.syncFocus();
      }

      // Swiper's ResizeObserver re-measures every slide, on the next frame, when the container's box differs from
      // its width/height. On load it always does, though no slide would change: those are rounded (clientWidth) and
      // the box is fractional, height was read before the slides had a size, and a hidden slider has none. Handing
      // Swiper the box leaves it only the real changes. Height only matters to vertical and auto-width sliders.
      ignoreHarmlessResize() {
        const slider = this.slider;
        const observer = new ResizeObserver(([{ contentRect }]) => {
          const usesHeight = !slider.isHorizontal() || slider.params.slidesPerView === 'auto';
          if (Math.abs(contentRect.width - (slider.width || 0)) < 1) slider.width = contentRect.width;
          if (!usesHeight || Math.abs(contentRect.height - (slider.height || 0)) < 1) slider.height = contentRect.height;
        });
        observer.observe(this.container);
        slider.on('destroy', () => observer.disconnect());
      }

      // Images on slides about to show would otherwise start loading only once they are on screen.
      watchUpcomingImages() {
        const preload = () => this.preloadUpcomingImages();
        this.slider.on('slideChange', preload);
        this.container.addEventListener('pointerenter', preload, { once: true });
        if (!this.options.autoplay) return;
        if (document.readyState === 'complete') preload();
        else window.addEventListener('load', preload, { once: true });
      }

      preloadUpcomingImages() {
        const slider = this.slider;
        if (!slider || slider.destroyed || !slider.initialized) return;
        const perView = Math.max(1, Math.ceil(slider.slidesPerViewDynamic()));
        Array.from(slider.slides)
          .slice(slider.activeIndex, slider.activeIndex + perView * 2)
          .forEach((slide) => {
            slide.querySelectorAll('img[loading="lazy"]').forEach((image) => {
              image.loading = 'eager';
            });
          });
      }

      destroy() {
        // Swiper's destroy also drops the listeners added through `slider.on`, but leaves the kit's markup.
        if (this.slider) this.slider.destroy(true, true);
        this.slider = null;
        if (this.focusController) this.focusController.abort();
        if (this.kit.fadePartial) {
          this.container.querySelectorAll('.is-partial').forEach((slide) => slide.classList.remove('is-partial'));
        }
        if (this.dotsEl) this.dotsEl.replaceChildren();
        if (this.fractionEl) this.fractionEl.replaceChildren();
      }

      applyKit() {
        const { controls, fraction } = this.kit;
        const options = this.options;

        const noMotion = FoxTheme.config.motionReduced || FoxTheme.config.disableAnimations;
        if (noMotion && options.speed === undefined) options.speed = 0;
        if (!controls) return;

        const prevEl = controls.querySelector('[data-carousel-prev]');
        const nextEl = controls.querySelector('[data-carousel-next]');
        if (prevEl && nextEl && !options.navigation) options.navigation = { prevEl, nextEl };

        const dotsEl = controls.querySelector('[data-carousel-dots]');
        if (dotsEl && !options.pagination) {
          this.dotsEl = dotsEl;
          options.pagination = {
            el: dotsEl,
            clickable: true,
            renderBullet: (index, className) => `<button type="button" class="${className}"></button>`,
          };
          options.on = this.chainEvents(options.on, {
            paginationRender: () => this.labelDots(dotsEl),
            paginationUpdate: () => this.labelDots(dotsEl),
          });
        }

        this.fractionEl = controls.querySelector('[data-carousel-fraction]');
        if (this.fractionEl && fraction === 'pages') this.groupByPage(options);
      }

      // One page = the whole slides in view, so the pager counts pages instead of slides. Swiper needs an
      // integer group (2.5 per view → 2), and the breakpoints are copied so the caller's object is untouched.
      groupByPage(options) {
        const group = (params) => {
          if (typeof params.slidesPerView !== 'number' || params.slidesPerGroup !== undefined) return params;
          return { ...params, slidesPerGroup: Math.max(1, Math.floor(params.slidesPerView)) };
        };
        Object.assign(options, group(options));
        if (options.breakpoints) {
          options.breakpoints = Object.fromEntries(
            Object.entries(options.breakpoints).map(([width, params]) => [width, group(params)])
          );
        }
      }

      // Mouse and touch focus (`:focus-visible` false) are left alone, so a click on a partly shown card
      // follows its link instead of sliding first. Same visibility rule as updatePartial, read from the
      // rects after the scroll reset.
      // The reveal reads the focus when it runs, not the slide focused when it was queued: fast Tab outruns a
      // running slide, and a reveal bound to an earlier card would slide back. One reveal is queued at a time
      // (Swiper 8's emit skips the next `once` handler when one removes itself, so stacked ones fire late).
      syncFocus() {
        this.focusController = new AbortController();
        const { signal } = this.focusController;
        const container = this.container;
        let queued = false;

        // The browser scrolls a clipped ancestor too (the kit's `clip`, overflow hidden) to reveal a focused card.
        [container, this.kit.clip].filter(Boolean).forEach((element) => {
          element.addEventListener(
            'scroll',
            () => {
              element.scrollLeft = 0;
              element.scrollTop = 0;
            },
            { signal }
          );
        });
        container.addEventListener(
          'focusin',
          (event) => {
            const slider = this.slider;
            const slideSelector = slider && `.${slider.params.slideClass}`;
            if (!slider || !event.target.closest(slideSelector) || !event.target.matches(':focus-visible')) return;
            const reveal = () => {
              queued = false;
              if (this.slider !== slider) return;
              const focused = document.activeElement;
              if (!focused || !container.contains(focused) || !focused.matches(':focus-visible')) return;
              const slide = focused.closest(slideSelector);
              const index = Array.from(slider.slides).indexOf(slide);
              if (index === -1) return;
              const box = container.getBoundingClientRect();
              const clip = this.kit.clip ? this.kit.clip.getBoundingClientRect() : box;
              const rect = slide.getBoundingClientRect();
              const inside = slider.isHorizontal()
                ? rect.left >= Math.max(box.left, clip.left) - 1 && rect.right <= Math.min(box.right, clip.right) + 1
                : rect.top >= box.top - 1 && rect.bottom <= box.bottom + 1;
              if (!inside) slider.slideTo(index);
            };
            // A slide already under way (the section's own focus handler, autoplay) is measured where it lands.
            requestAnimationFrame(() => {
              if (this.slider !== slider) return;
              if (!slider.animating) reveal();
              else if (!queued) {
                queued = true;
                slider.once('transitionEnd', reveal);
              }
            });
          },
          { signal }
        );
      }

      watch(handler, events) {
        handler = handler.bind(this);
        this.slider.on(events, handler);
        handler();
      }

      chainEvents(existing = {}, added) {
        const merged = { ...existing };
        Object.entries(added).forEach(([name, handler]) => {
          const previous = existing[name];
          merged[name] = previous
            ? function (...args) {
                previous.apply(this, args);
                handler.apply(this, args);
              }
            : handler;
        });
        return merged;
      }

      labelDots(dotsEl) {
        const bullets = dotsEl.querySelectorAll('.swiper-pagination-bullet');
        const { labelSlide = '', labelOf = '' } = dotsEl.dataset;
        const activeClass = this.options.pagination.bulletActiveClass || 'swiper-pagination-bullet-active';
        bullets.forEach((bullet, index) => {
          bullet.setAttribute('aria-label', `${labelSlide} ${index + 1} ${labelOf} ${bullets.length}`);
          if (bullet.classList.contains(activeClass)) {
            bullet.setAttribute('aria-current', 'true');
          } else {
            bullet.removeAttribute('aria-current');
          }
        });
      }

      updateFraction() {
        const slider = this.slider;
        const total = Math.max(slider.snapGrid.length, 1);
        const current = Math.min(slider.snapIndex + 1, total);
        const separator = document.createElement('span');
        separator.setAttribute('aria-hidden', 'true');
        separator.textContent = '/';
        const label = document.createElement('span');
        label.className = 'visually-hidden';
        label.textContent = ` ${this.fractionEl.dataset.labelOf || ''} `;
        this.fractionEl.replaceChildren(String(current), separator, label, String(total));
      }

      // Same maths as Swiper's updateSlidesProgress, but for slides that are fully visible. slidesGrid
      // holds each slide's start, so no watchSlidesProgress (swiperSlideOffset) is needed.
      updatePartial() {
        const slider = this.slider;
        const offsetCenter = slider.rtlTranslate ? slider.translate : -slider.translate;
        let start = 0;
        let end = slider.size;
        if (this.kit.clip) {
          const box = this.kit.clip.getBoundingClientRect();
          const rect = this.container.getBoundingClientRect();
          start = Math.max(0, slider.rtlTranslate ? rect.right - box.right : box.left - rect.left);
          end = Math.min(slider.size, slider.rtlTranslate ? rect.right - box.left : box.right - rect.left);
        }
        Array.from(slider.slides).forEach((slide, index) => {
          const before = slider.slidesGrid[index] - offsetCenter;
          const after = before + slider.slidesSizesGrid[index];
          const inside = before >= start - 1 && after <= end + 1;
          // A slide wider than the visible span is never fully inside; it counts as shown while it covers it.
          const covers = before <= start + 1 && after >= end - 1;
          slide.classList.toggle('is-partial', !inside && !covers);
        });
      }
    }
    return Carousel;
  })();

  FoxTheme.delayUntilInteraction = (function () {
    class ScriptLoader {
      constructor(callback, delay = 5000) {
        this.loadScriptTimer = setTimeout(callback, delay);
        this.userInteractionEvents = [
          'mouseover',
          'mousemove',
          'keydown',
          'touchstart',
          'touchend',
          'touchmove',
          'wheel',
        ];

        this.onScriptLoader = this.triggerScriptLoader.bind(this, callback);
        this.userInteractionEvents.forEach((event) => {
          window.addEventListener(event, this.onScriptLoader, {
            passive: !0,
          });
        });
      }

      triggerScriptLoader(callback) {
        callback();
        clearTimeout(this.loadScriptTimer);
        this.userInteractionEvents.forEach((event) => {
          window.removeEventListener(event, this.onScriptLoader, {
            passive: !0,
          });
        });
      }
    }

    return ScriptLoader;
  })();

  FoxTheme.Currency = (function () {
    const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  /**
   * Patches a rendered `price.liquid` block in place to match a variant.
   * Shared by the sticky ATC bar and the product page's optimistic variant update so both write the
   * same DOM the same way. Text and visibility only — structural cases (`f-price--no-compare`,
   * quantity price breaks) stay the server render's job.
   */
  FoxTheme.updatePriceFromVariant = (root, variant) => {
    if (!root || !variant) return;

    const classes = {
      onSale: 'f-price--on-sale',
      soldOut: 'f-price--sold-out',
    };
    const selectors = {
      priceWrapper: '.f-price',
      salePrice: '.f-price-item--sale',
      compareAtPrice: ['.f-price-item--regular'],
      unitPriceWrapper: '.f-price__unit-wrapper',
    };
    const moneyFormat = FoxTheme.settings.moneyFormat;
    const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(selectors, root);

    if (!priceWrapper) return;

    const unitPrice = unitPriceWrapper && unitPriceWrapper.querySelector('.f-price__unit');
    const { compare_at_price, price, unit_price_measurement } = variant;
    const onSale = compare_at_price && compare_at_price > price;

    priceWrapper.classList.toggle(classes.onSale, !!onSale);
    priceWrapper.classList.toggle(classes.soldOut, !variant.available);

    if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

    if (compareAtPrice && compareAtPrice.length) {
      const regularAmount = onSale ? compare_at_price : price;
      // The compare-at copy wraps its amount in <s>; write inside it or the strikethrough drops until
      // the section render puts it back.
      compareAtPrice.forEach(
        (item) =>
          ((item.querySelector('s') || item).innerHTML = FoxTheme.Currency.formatMoney(regularAmount, moneyFormat))
      );
    }

    if (!unitPriceWrapper) return;

    if (unit_price_measurement && unitPrice) {
      unitPriceWrapper.classList.remove('hidden');
      unitPrice.innerHTML = `<span>${FoxTheme.Currency.formatMoney(
        variant.unit_price,
        moneyFormat
      )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(variant)}</span>`;
    } else {
      unitPriceWrapper.classList.add('hidden');
    }
  };

  new FoxTheme.delayUntilInteraction(() => {
    document.body.removeAttribute('data-initializing');
  });

  // layout/theme.liquid sets the value before layout; this corrects it on a page too short to have a scrollbar.
  FoxTheme.DOMready(() => FoxTheme.utils.onceLaidOut(document.body, FoxTheme.utils.setScrollbarWidth));
  window.addEventListener('resize', FoxTheme.utils.throttle(FoxTheme.utils.setScrollbarWidth));

  const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
  FoxTheme.config.mqlMobile = mql.matches;
  mql.onchange = (event) => {
    if (event.matches) {
      FoxTheme.config.mqlMobile = true;
      document.dispatchEvent(new CustomEvent('matchMobile'));
    } else {
      FoxTheme.config.mqlMobile = false;
      document.dispatchEvent(new CustomEvent('unmatchMobile'));
    }
  };

  const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
  FoxTheme.config.mqlTablet = mqlTablet.matches;
  mqlTablet.onchange = (event) => {
    if (event.matches) {
      FoxTheme.config.mqlTablet = true;
      document.dispatchEvent(new CustomEvent('matchTablet'));
    } else {
      FoxTheme.config.mqlTablet = false;
      document.dispatchEvent(new CustomEvent('unmatchTablet'));
    }
  };
})();

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  FoxTheme.focusVisiblePolyfill();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    if (!oldNode || !newContent) return;
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

class PageTransition extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('beforeunload', () => {
      document.body.classList.add('page-loading');
    });

    window.addEventListener('DOMContentLoaded', () => {
      FoxTheme.Motion.animate(this, { visibility: 'hidden', opacity: 0 }, { duration: 1 });

      document.body.classList.add('page-loaded');
      document.dispatchEvent(new CustomEvent('page:loaded'));
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        document.body.classList.remove('page-loading');
      }
    });
  }
}
customElements.define('page-transition', PageTransition);

const clearModalComponentCount = new WeakMap();
class ModalComponent extends HTMLElement {
  constructor() {
    super();
    this.events = {
      handleAfterHide: 'modal:handleAfterHide',
      handleAfterShow: 'modal:handleAfterShow',
    };

    this.classes = {
      show: 'modal-show',
      showing: 'modal-showing',
    };
  }

  static get observedAttributes() {
    return ['id', 'open'];
  }

  get isLockingNeeded() {
    return false;
  }

  get requiresBodyAppended() {
    return false;
  }

  get controls() {
    return Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`));
  }

  get designMode() {
    return this.hasAttribute('shopify-design-mode');
  }

  get open() {
    return this.hasAttribute('open');
  }

  get overlay() {
    // Check if the _overlay property is already set
    if (!this._overlay) {
      // If not set, find the element and cache it
      this._overlay = this.querySelector('.fixed-overlay');
    }

    // Return the cached element
    return this._overlay;
  }

  get focusElement() {
    const button = this.querySelector('button');
    if (button) return button;

    const focusableElements = FoxTheme.a11y.getFocusableElements(this);
    return focusableElements[0] || this;
  }
  connectedCallback() {
    // Initialize the AbortController
    this.abortController = new AbortController();

    // Add click event listeners to all controls
    this.controls.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this), {
        signal: this.abortController.signal,
      });
    });

    // Add keyup event listener to document for handling the Escape key
    document.addEventListener(
      'keyup',
      (event) => {
        if (event.code === 'Escape') {
          this.hide();
        }
      },
      { signal: this.abortController.signal }
    );

    // Additional setup for Shopify design mode
    if (this.designMode && Shopify.designMode) {
      const section = this.closest('.shopify-section');
      section.addEventListener(
        'shopify:section:select',
        (event) => {
          this.show(null, !event.detail.load);
        },
        {
          signal: this.abortController.signal,
        }
      );
      section.addEventListener(
        'shopify:section:deselect',
        () => {
          this.hide();
        },
        {
          signal: this.abortController.signal,
        }
      );
    }
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'open':
        // The overlay only closes the modal on click; aria-expanded is not valid on its plain div.
        this.controls
          .filter((control) => !control.matches('.fixed-overlay'))
          .forEach((button) => button.setAttribute('aria-expanded', newValue === null ? 'false' : 'true'));

        if (oldValue === null && (newValue === '' || newValue === 'immediate')) {
          this.applyDialogSemantics();
          this.hidden = false;
          this.removeAttribute('inert');

          this.parentElementBeforeAppend = null;
          if (this.requiresBodyAppended && this.parentElement !== document.body) {
            this.parentElementBeforeAppend = this.parentElement;
            document.body.append(this);
          }
          const handleShowTransitionPromise = this.handleShowTransition(newValue !== 'immediate') || Promise.resolve();
          handleShowTransitionPromise.then(() => {
            this.handleAfterShow();
            this.dispatchEvent(new CustomEvent(this.events.handleAfterShow, { bubbles: true }));
          });
        } else if (oldValue !== null && newValue === null) {
          this.setAttribute('inert', '');

          const handleHideTransitionPromise = this.handleHideTransition() || Promise.resolve();
          handleHideTransitionPromise.then(() => {
            this.handleAfterHide();

            if (!this.hasAttribute('inert')) return;

            if (this.parentElement === document.body && this.parentElementBeforeAppend) {
              this.parentElementBeforeAppend.appendChild(this);
              this.parentElementBeforeAppend = null;
            }
            this.dispatchEvent(new CustomEvent(this.events.handleAfterHide, { bubbles: true }));

            this.hidden = true;
          });
        }
        this.dispatchEvent(new CustomEvent('toggle', { bubbles: true }));

        break;
    }
  }

  // A panel that carries its own dialog role (detail-list) keeps it. Otherwise the modal is named by its
  // first heading, or by the control that opened it when it has none.
  applyDialogSemantics() {
    if (this.querySelector(':scope > [role="dialog"]')) return;

    this.setAttribute('role', 'dialog');
    this.setAttribute('aria-modal', 'true');
    if (this.hasAttribute('aria-label') || this.hasAttribute('aria-labelledby')) return;

    const heading = this.querySelector('h1, h2, h3, h4, h5, h6');
    if (heading) {
      if (!heading.id) heading.id = `${this.id}-heading`;
      this.setAttribute('aria-labelledby', heading.id);
      return;
    }

    const opener = this.activeElement || this.controls.find((control) => !this.contains(control));
    const label = opener && (opener.getAttribute('aria-label') || opener.textContent.trim());
    if (label) this.setAttribute('aria-label', label);
  }

  onButtonClick(event) {
    event.preventDefault();
    if (this.open) {
      this.hide();
    } else {
      this.show(event.currentTarget);
    }
  }

  hide() {
    if (this.open) {
      this.removeAttribute('open');
      return FoxTheme.utils.waitForEvent(this, this.events.handleAfterHide);
    }
  }

  show(activeElement = null, animate = true) {
    if (!this.shouleBeShow()) {
      return;
    }

    if (!this.open) {
      this.prepareToShow();
      this.activeElement = activeElement;
      this.setAttribute('open', animate ? '' : 'immediate');

      if (this.isLockingNeeded) {
        document.body.classList.add(this.classes.showing);
      }

      return FoxTheme.utils.waitForEvent(this, this.events.handleAfterShow);
    }
  }

  handleAfterHide() {
    setTimeout(() => {
      // Remove trap focus from the active element
      FoxTheme.a11y.removeTrapFocus(this.activeElement);

      // Conditionally manage locking behavior
      if (this.isLockingNeeded) {
        // Decrement the lock layer count for the ModalElement
        const currentModalCount = clearModalComponentCount.get(ModalComponent) - 1;
        clearModalComponentCount.set(ModalComponent, currentModalCount);

        // Toggle the 'open' class on the body based on the current lock count
        document.body.classList.toggle(this.classes.show, currentModalCount > 0);
      }
    });
  }

  handleAfterShow() {
    // Trap focus on the specified elements
    FoxTheme.a11y.trapFocus(this, this.focusElement);

    // Check if locking is needed
    if (this.isLockingNeeded) {
      // Increment the lock layer count for the ModalElement
      const currentLockCount = clearModalComponentCount.get(ModalComponent) + 1;
      clearModalComponentCount.set(ModalComponent, currentLockCount);

      // Manage class changes on the document body
      document.body.classList.remove(this.classes.showing);
      document.body.classList.add(this.classes.show);
    }
  }

  shouleBeShow() {
    return true;
  }

  prepareToShow() {}

  handleShowTransition() {
    // if (FoxTheme.config.disableAnimations) {
    //   this.setAttribute('active', '');
    //   return Promise.resolve();
    // }

    // Start a timeout to set an attribute
    setTimeout(() => {
      this.setAttribute('active', '');
    }, 75);

    // Return a promise that resolves when the transition ends
    return new Promise((resolve) => {
      this.overlay.addEventListener('transitionend', resolve, { once: true });
    });
  }

  handleHideTransition() {
    // Immediately remove the 'active' attribute
    this.removeAttribute('active');

    // if (FoxTheme.config.disableAnimations) return Promise.resolve();

    // Return a promise that resolves when the transition ends
    return new Promise((resolve) => {
      this.overlay.addEventListener('transitionend', resolve, { once: true });
    });
  }
}
customElements.define('modal-component', ModalComponent);
clearModalComponentCount.set(ModalComponent, 0);

class BasicModal extends ModalComponent {
  constructor() {
    super();
  }

  get isLockingNeeded() {
    return true;
  }

  get requiresBodyAppended() {
    return true;
  }
}
customElements.define('basic-modal', BasicModal);

class DrawerComponent extends ModalComponent {
  constructor() {
    super();
    this.events = {
      handleAfterHide: 'drawer:handleAfterHide',
      handleAfterShow: 'drawer:handleAfterShow',
    };
  }
  get isLockingNeeded() {
    return true;
  }
  get requiresBodyAppended() {
    return true;
  }
}
customElements.define('drawer-component', DrawerComponent);

class AccordionDetails extends HTMLDetailsElement {
  constructor() {
    super();
    this.hasAnimation = true;
    this.initAccordion();
  }

  initAccordion() {
    this.isOpen = this.hasAttribute('open');
    this.summaryElement = this.querySelector('summary');
    this.contentElement = this.querySelector('summary + *');
    this.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');

    this.summaryElement.addEventListener('click', this.toggleAccordion.bind(this));

    if (Shopify.designMode) {
      this.designModeEventSetup();
    }
  }

  static get observedAttributes() {
    return ['open'];
  }

  get open() {
    return this.isOpen;
  }

  set open(value) {
    if (value !== this.isOpen) {
      this.isOpen = value;

      if (this.isConnected) {
        this.animateAccordion(value);
      } else {
        if (value) {
          this.setAttribute('open', '');
        } else {
          this.removeAttribute('open');
        }
      }

      this.setAttribute('aria-expanded', value ? 'true' : 'false');
      this.setAttribute('aria-controls', this.contentElement.id);

      this.handleAfterToggle();
    }
  }

  handleAfterToggle() {}

  handleAfterAnimated() {}

  toggleAccordion(event) {
    event.preventDefault();
    this.open = !this.open;
  }

  close() {
    this.isOpen = false;
    this.animateAccordion(false);
  }

  /**
   * Set open status without animation
   * @param {*} value
   */
  toggle(value) {
    this.hasAnimation = false;
    this.open = value;
    this.hasAnimation = true;
  }

  async animateAccordion(isOpen) {
    // if (FoxTheme.config.disableAnimations) {
    //   if (isOpen) {
    //     this.setAttribute('open', '');
    //   } else {
    //     this.removeAttribute('open');
    //   }
    //   this.handleAfterAnimated();
    //   return;
    // }

    // When animation is disabled (programmatic toggles such as responsive breakpoint
    // changes), bypass Motion entirely. A WAAPI animation — even with duration 0 — can
    // leave a committed inline height or never resolve its `.finished` promise on iOS,
    // which leaves the accordion stuck at a wrong height after closing. Snapping the
    // native `open` attribute directly and clearing any inline styles avoids all of that.
    if (!this.hasAnimation) {
      if (isOpen) {
        this.setAttribute('open', '');
      } else {
        this.removeAttribute('open');
      }

      this.style.removeProperty('height');
      this.style.removeProperty('overflow');

      // iOS Safari sometimes does not re-layout a <details> when the `open` attribute is
      // toggled programmatically, leaving the content occupying space (wrong height).
      // Force a synchronous reflow to make the browser collapse/expand it immediately.
      // eslint-disable-next-line no-unused-expressions
      if (FoxTheme.config.isIOS) this.offsetHeight;

      this.handleAfterAnimated();
      return;
    }

    this.style.overflow = 'hidden';

    if (isOpen) {
      this.setAttribute('open', '');

      await FoxTheme.Motion.timeline([
        [
          this,
          { height: [`${this.summaryElement.clientHeight + 1}px`, `${this.scrollHeight + 1}px`] },
          { duration: 0.25, easing: 'ease' },
        ],
        [
          this.contentElement,
          { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
          { duration: 0.15, at: '<' },
        ],
      ]).finished;
    } else {
      await FoxTheme.Motion.timeline([
        [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
        [
          this,
          { height: [`${this.clientHeight + 1}px`, `${this.summaryElement.clientHeight + 1}px`] },
          { duration: 0.25, at: '<', easing: 'ease' },
        ],
      ]).finished;

      this.removeAttribute('open');
    }

    this.style.height = 'auto';
    this.style.overflow = 'visible';

    this.handleAfterAnimated();
  }

  designModeEventSetup() {
    this.addEventListener('shopify:block:select', () => {
      this.open = true;
    });

    this.addEventListener('shopify:block:deselect', (event) => {
      // Theme block rows carry the editor attributes themselves, so a child block's deselect bubbles
      // up to them; only the row's own deselect closes it.
      if (event.target !== this) return;
      this.open = false;
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      this.setAttribute('aria-controls', this.contentElement.id);
    }
  }
}
customElements.define('accordion-details', AccordionDetails, { extends: 'details' });

class AccordionGroup extends AccordionDetails {
  constructor() {
    super();
  }

  handleAfterToggle() {
    if (!this.isOpen) return;

    const parent = this.closest('.accordion-parent') || document;
    // The accordion theme block's "Several rows at once" keeps the siblings open.
    if (parent !== document && parent.hasAttribute('data-accordion-multiple')) return;
    // Only rows of this accordion: an accordion nested in a row's content is not a sibling.
    const openedSiblings = Array.from(parent.querySelectorAll('details[is="accordion-group"]')).filter(
      (details) =>
        details !== this &&
        details.open &&
        (parent === document || details.closest('.accordion-parent') === parent)
    );

    if (!openedSiblings.length) return;

    // Measured before the siblings start collapsing, while the layout is still untouched.
    const summaryTop = this.getBoundingClientRect().top;
    const shiftsViewport = openedSiblings.some((details) => details.getBoundingClientRect().top < summaryTop);

    openedSiblings.forEach((details) => {
      details.open = false;
    });

    if (shiftsViewport) this.keepSummaryInPlace(summaryTop);
  }

  /**
   * A sibling collapsing ABOVE this accordion pulls the page up, so the summary the user
   * just tapped slides away from where they tapped it -- very visible on mobile when the
   * previous row held a long block of content. Pin the summary to its viewport position
   * for the duration of the closing animation instead.
   * @param {number} summaryTop viewport offset to keep this accordion at
   */
  keepSummaryInPlace(summaryTop) {
    const controller = new AbortController();
    const stop = () => controller.abort();

    // Never fight the user: if they start scrolling themselves, hand the scroll back.
    window.addEventListener('wheel', stop, { passive: true, signal: controller.signal });
    window.addEventListener('touchmove', stop, { passive: true, signal: controller.signal });

    let frames = 0;
    const maxFrames = 45; // ~0.75s, comfortably longer than the 0.25s close animation

    const anchor = () => {
      if (controller.signal.aborted) return;

      const delta = this.getBoundingClientRect().top - summaryTop;
      if (Math.abs(delta) >= 1) {
        window.scrollTo({ top: window.scrollY + delta, behavior: 'instant' });
      }

      if (++frames < maxFrames) {
        requestAnimationFrame(anchor);
      } else {
        controller.abort();
      }
    };

    requestAnimationFrame(anchor);
  }
}
customElements.define('accordion-group', AccordionGroup, { extends: 'details' });

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    if (this.hasAttribute('style')) return;

    if (this.dataset.from) {
      this.initProgress();
    }

    // if (FoxTheme.config.disableAnimations || FoxTheme.config.motionReduced) {
    //   this.init();
    //   return;
    // }

    FoxTheme.Motion.inView(this, this.init.bind(this));
  }

  init() {
    this.setPercentage(this.dataset.value, this.dataset.max);
  }

  initProgress() {
    this.setPercentage(this.dataset.from, this.dataset.max);
  }

  setPercentage(val1, val2) {
    this.style.setProperty('--percent', `${(parseInt(val1) / parseInt(val2)) * 100}%`);
  }
}
customElements.define('progress-bar', ProgressBar);

class CartCount extends HTMLElement {
  constructor() {
    super();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  get itemCount() {
    return parseInt(this.innerText);
  }

  onCartUpdate(event) {
    if (event.cart.errors) return;

    const previousCount = this.itemCount;

    if (event.cart.item_count > 99) {
      this.innerHTML = `<span class="text-sm">99+</span>`;
      this.classList.add('cart-count--small-medium');
    } else {
      this.innerText = event.cart.item_count;
      this.classList.remove('cart-count--small-medium');
    }
    this.hidden = this.itemCount === 0;

    const { itemCountOne, itemCountOther } = FoxTheme.cartStrings;
    const label = (event.cart.item_count === 1 ? itemCountOne : itemCountOther).replace('[count]', event.cart.item_count);
    this.setAttribute('aria-label', label);

    const status = document.getElementById('CartStatus');
    if (status && this.itemCount !== previousCount && status.textContent !== label) status.textContent = label;

    const method = this.itemCount === 0 ? 'remove' : 'add';
    document.documentElement.classList[method]('cart-has-items');
  }
}
customElements.define('cart-count', CartCount);

class QuantityInput extends HTMLElement {
  quantityUpdateUnsubscriber = undefined;
  quantityBoundriesUnsubscriber = undefined;
  quantityRulesUnsubscriber = undefined;

  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }

  get productId() {
    return this.getAttribute('data-product-id');
  }

  get input() {
    return this.querySelector('input');
  }

  get value() {
    return this.input.value;
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.buttons = Array.from(this.querySelectorAll('button'));
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this), {
      signal: this.abortController.signal,
    });

    this.input.addEventListener('focus', () => setTimeout(() => this.input.select()), {
      signal: this.abortController.signal,
    });

    this.buttons.forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this), { signal: this.abortController.signal })
    );

    this.validateQtyRules();

    this.quantityUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
    this.quantityBoundriesUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries,
      this.setQuantityBoundries.bind(this)
    );
    this.quantityRulesUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules,
      this.updateQuantityRules.bind(this)
    );

    this.currentValue = this.value;

    // Keeps the main product form and the sticky-atc-bar quantity inputs of the same product in sync (only these two).
    // The sticky bar is its own section, so its data-section-id differs from the main product's: match on productId.
    // Only the product-info flagged data-quantity-sync (main-product.liquid) takes part: a quick view or a featured
    // product of the same product must not move the sticky bar.
    this.syncScope = this.closest('product-info[data-quantity-sync]')
      ? 'main'
      : this.closest('sticky-atc-bar')
        ? 'sticky'
        : null;
    if (this.syncScope) {
      document.addEventListener('quantity:sync', this.onSyncProductQuantity.bind(this), {
        signal: this.abortController.signal,
      });
      // A freshly connected input (the sticky bar re-renders its quantity on a variant change, the editor reloads
      // sections) starts from the server's min: take the buyer's current quantity from the other side.
      this.adoptPartnerValue();
    }
  }

  disconnectedCallback() {
    this.abortController.abort();

    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
    if (this.quantityBoundriesUnsubscriber) {
      this.quantityBoundriesUnsubscriber();
    }
    if (this.quantityRulesUnsubscriber) {
      this.quantityRulesUnsubscriber();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      if (parseInt(this.input.getAttribute('data-min')) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.getAttribute('data-min');
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    // Set the final value before announcing it, so listeners (price per item, the quantity sync)
    // never see the intermediate one.
    if (this.input.getAttribute('data-min') === previousValue && event.currentTarget.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  onInputChange() {
    if (this.input.value === '') {
      this.input.value = parseInt(this.input.min);
    }
    setTimeout(() => {
      this.validateQtyRules();
    }, 350);

    this.announceSync();
  }

  announceSync() {
    if (!this.syncScope || this.isSyncing) return;
    document.dispatchEvent(
      new CustomEvent('quantity:sync', {
        detail: { scope: this.syncScope, productId: this.productId, value: this.input.value },
      })
    );
  }

  onSyncProductQuantity({ detail: { scope, productId, value } }) {
    if (!productId || productId !== this.productId || scope === this.syncScope) return;
    const nextValue = this.clampValue(value);
    if (this.input.value !== nextValue) {
      // Announce the change like a buyer's edit (price per item listens), without syncing it back.
      this.isSyncing = true;
      this.input.value = nextValue;
      this.input.dispatchEvent(this.changeEvent);
      this.isSyncing = false;
    }

    // The rules here refused part of it: let the sender follow what this side can actually hold.
    if (nextValue !== value) this.announceSync();
  }

  // The other side of the pair: the sticky bar for a main product input, and the other way round.
  getSyncPartner() {
    const selector = this.syncScope === 'main' ? 'sticky-atc-bar' : 'product-info[data-quantity-sync]';
    return document.querySelector(`${selector}[data-product-id="${this.productId}"] quantity-input`);
  }

  adoptPartnerValue() {
    const partner = this.getSyncPartner();
    if (!partner || partner === this || partner.value === undefined) return;

    const nextValue = this.clampValue(partner.value);
    if (nextValue !== this.input.value) {
      this.input.value = nextValue;
      this.validateQtyRules();
    }
    // The rules here refused part of it: let the partner follow what this side can actually hold.
    if (nextValue !== partner.value) this.announceSync();
  }

  // The input's own min/max are the effective rules (already adjusted for what the cart holds).
  clampValue(value) {
    let next = parseInt(value);
    if (isNaN(next)) return this.input.value;
    const min = parseInt(this.input.min);
    const max = parseInt(this.input.max);
    if (!isNaN(min)) next = Math.max(next, min);
    if (!isNaN(max)) next = Math.min(next, max);
    return String(next);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector('button[name="minus"]');
      if (buttonMinus) buttonMinus.toggleAttribute('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const buttonPlus = this.querySelector('button[name="plus"]');
      if (buttonPlus) buttonPlus.toggleAttribute('disabled', parseInt(value) >= parseInt(this.input.max));
    } else {
      const buttonPlus = this.querySelector('button[name="plus"]');
      if (buttonPlus) buttonPlus.removeAttribute('disabled');
    }
  }

  updateQuantityRules({ data: { sectionId, productId, parsedHTML } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;

    // Helper function to find element in both document and template content
    const findElementById = (container, id) => {
      // First try direct search
      let element = container.getElementById ? container.getElementById(id) : container.querySelector(`#${id}`);

      if (!element) {
        // Search in template contents
        const templates = container.querySelectorAll('template');
        for (const template of templates) {
          element = template.content.getElementById
            ? template.content.getElementById(id)
            : template.content.querySelector(`#${id}`);
          if (element) break;
        }
      }

      return element;
    };

    const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
    const quantityFormUpdated = findElementById(parsedHTML, `QuantityForm-${sectionId}`);
    const quantityForm = this.closest(`#QuantityForm-${sectionId}`);

    if (!quantityFormUpdated) {
      console.warn(`QuantityForm-${sectionId} not found in parsedHTML`);
      return;
    }

    for (let selector of selectors) {
      const current = quantityForm.querySelector(selector);
      const updated = quantityFormUpdated.querySelector(selector);
      if (!current || !updated) continue;

      if (selector === '.quantity__input') {
        const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
        for (let attribute of attributes) {
          const valueUpdated = updated.getAttribute(attribute);
          if (valueUpdated !== null) {
            current.setAttribute(attribute, valueUpdated);
          } else {
            current.removeAttribute(attribute);
          }
        }
      } else {
        current.innerHTML = updated.innerHTML;
      }
    }
  }

  setQuantityBoundries({ data: { sectionId, productId } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    const data = {
      cartQuantity: this.input.hasAttribute('data-cart-quantity')
        ? parseInt(this.input.getAttribute('data-cart-quantity'))
        : 0,
      min: this.input.hasAttribute('data-min') ? parseInt(this.input.getAttribute('data-min')) : 1,
      max: this.input.hasAttribute('data-max') ? parseInt(this.input.getAttribute('data-max')) : null,
      step: this.input.hasAttribute('step') ? parseInt(this.input.getAttribute('step')) : 1,
    };

    let min = data.min;
    const max = data.max === null ? data.max : data.max - data.cartQuantity;
    if (max !== null) min = Math.min(min, max);
    if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

    this.input.min = min;

    if (max) {
      this.input.max = max;
    } else {
      this.input.removeAttribute('max');
    }
    this.input.value = min;

    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate, undefined);
  }
}
customElements.define('quantity-input', QuantityInput);

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.input = this.querySelector('input');
    this.buttons = Array.from(this.querySelectorAll('button'));
    this.changeEvent = new Event('change', { bubbles: true });

    this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)), {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      this.input.quantity = this.input.quantity + 1;
    } else {
      this.input.quantity = this.input.quantity - 1;
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-selector', QuantitySelector);

const onYouTubeApiLoaded = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
class VideoElement extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    if (this.posterElement) {
      this.posterElement.addEventListener('click', this.handlePosterClick.bind(this), { signal });
    }
    this.addEventListener('click', this.handleControlClick.bind(this), { signal });

    // `autoplay-safe` opts out of autoplay for reduced motion and Save-Data.
    this.autoplayBlocked =
      this.hasAttribute('autoplay-safe') && (FoxTheme.config.motionReduced || navigator.connection?.saveData === true);

    if (this.autoplay && !this.autoplayBlocked) {
      this.stopInView = FoxTheme.Motion.inView(this, () => {
        if (!this.paused) {
          this.play();
        }

        return () => {
          this.pause();
        };
      });
    }

    this.updateControls();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.stopInView?.();
    this.stopInView = null;

    // A move (e.g. a carousel re-ordering slides) reconnects in the same task: only pause a removed video.
    // Removing an iframe already stops it; a detached <video> keeps playing.
    requestAnimationFrame(() => {
      if (!this.isConnected && !this.hasAttribute('source')) this.pause();
    });
  }

  get posterElement() {
    return this.querySelector('[id^="DeferredPoster-"]');
  }

  get controlledElement() {
    return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null;
  }

  get autoplay() {
    return this.hasAttribute('autoplay');
  }

  get playing() {
    return this.hasAttribute('playing');
  }

  get muted() {
    const video = this.hasAttribute('source') ? null : this.querySelector(':scope > video');
    if (video) return video.muted;
    if (this.mutedState !== undefined) return this.mutedState;

    const template = this.querySelector('template')?.content;
    if (this.hasAttribute('source')) {
      return (
        this.autoplay ||
        window.matchMedia('screen and (max-width: 1023px)').matches ||
        /[?&]muted?=1/.test(template?.querySelector('iframe')?.src || '')
      );
    }

    return Boolean(template?.querySelector('video')?.hasAttribute('muted'));
  }

  get player() {
    return (this.playerProxy =
      this.playerProxy ||
      new Proxy(this.initializePlayer(), {
        get: (target, prop) => {
          return async () => {
            target = await target;
            this.handlePlayerAction(target, prop);
          };
        },
      }));
  }

  static get observedAttributes() {
    return ['playing', 'suspended'];
  }

  handlePosterClick(event) {
    event.preventDefault();
    event.stopPropagation();

    this.togglePlay();
  }

  handleControlClick(event) {
    const button = event.target.closest('[data-video-action]');
    if (!button || !this.contains(button)) return;

    // Keep the click away from a parent card link or carousel.
    event.preventDefault();
    event.stopPropagation();

    if (button.dataset.videoAction === 'pause') this.togglePlay();
    if (button.dataset.videoAction === 'mute') this.toggleMute();
  }

  // A user action: the paused intent stops the in-view autoplay from resuming it.
  togglePlay() {
    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
  }

  mute() {
    this.setMuted(true);
  }

  unmute() {
    this.setMuted(false);
  }

  toggleMute() {
    this.setMuted(!this.muted);
  }

  setMuted(muted) {
    const video = this.hasAttribute('source') ? null : this.querySelector(':scope > video');
    if (video) {
      // The video's volumechange event records and announces the new state.
      video.muted = muted;
      return;
    }

    // Before the player loads, the state is applied when it does.
    if (this.playerProxy) this.player[muted ? 'mute' : 'unmute']();
    this.updateMuted(muted);
  }

  updateMuted(muted) {
    if (this.mutedState === muted) return;

    this.mutedState = muted;
    if (!muted && this.dataset.videoGroup) {
      // Only one video of a group plays sound.
      document.querySelectorAll('video-element[data-video-group]').forEach((element) => {
        if (element !== this && element.dataset.videoGroup === this.dataset.videoGroup && !element.muted) {
          element.mute();
        }
      });
    }
    this.dispatchEvent(new CustomEvent('video:volumechange', { bubbles: true, detail: { muted } }));
    this.updateControls();
  }

  // aria-pressed follows the player, not the click, so it never drifts.
  updateControls() {
    const pauseButton = this.querySelector('[data-video-action="pause"]');
    if (pauseButton) {
      const paused =
        !this.playing && (this.paused || !this.autoplay || this.autoplayBlocked || this.hasAttribute('suspended'));
      pauseButton.setAttribute('aria-pressed', paused);
    }

    const muteButton = this.querySelector('[data-video-action="mute"]');
    if (muteButton) muteButton.setAttribute('aria-pressed', this.muted);
  }

  play() {
    if (!this.playing) {
      this.player.play();
    }
  }

  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.updateControls();

    if (name === 'playing') {
      if (oldValue === null && newValue === '') {
        return this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
      }

      if (newValue === null) {
        return this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
      }
    }
  }

  initializePlayer() {
    if (this.hasAttribute('source')) {
      this.setAttribute('loaded', '');
      this.closest('.media')?.classList.remove('loading');

      return new Promise(async (resolve) => {
        const templateElement = this.querySelector('template');
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        const muteVideo = this.muted;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        if (this.getAttribute('source') === 'youtube') {
          if (!window.YT || !window.YT.Player) {
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          await onYouTubeApiLoaded;
          const player = new YT.Player(this.querySelector('iframe'), {
            events: {
              onReady: () => {
                if (muteVideo) {
                  player.mute();
                } else if (this.mutedState === false) {
                  player.unMute();
                }
                // The native YouTube controls send no volume event, so this is the last sync.
                this.updateMuted(muteVideo);
                resolve(player);
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute('playing', '');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute('playing');
                }
              },
            },
          });
        }
        if (this.getAttribute('source') === 'vimeo') {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = 'https://player.vimeo.com/api/player.js';
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          const player = new Vimeo.Player(this.querySelector('iframe'));
          if (muteVideo) {
            player.setMuted(true);
          } else if (this.mutedState === false) {
            player.setMuted(false);
          }
          this.updateMuted(muteVideo);
          player.on('volumechange', () => player.getMuted().then((muted) => this.updateMuted(muted)));
          player.on('play', () => {
            this.setAttribute('playing', '');
          });
          player.on('pause', () => this.removeAttribute('playing'));
          player.on('ended', () => this.removeAttribute('playing'));
          resolve(player);
        }
      });
    } else {
      this.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', '');
      this.closest('.media')?.classList.remove('loading');

      const player = this.querySelector('video');
      if (this.mutedState !== undefined) player.muted = this.mutedState;
      player.addEventListener('volumechange', () => this.updateMuted(player.muted));
      player.addEventListener('play', () => {
        this.setAttribute('playing', '');
        this.removeAttribute('suspended');
      });
      player.addEventListener('pause', () => {
        if (!player.seeking && player.paused) {
          this.removeAttribute('playing');
        }
      });
      return player;
    }
  }

  handlePlayerAction(target, prop) {
    if (this.getAttribute('source') === 'youtube') {
      const actions = { play: 'playVideo', pause: 'pauseVideo', mute: 'mute', unmute: 'unMute' };
      if (actions[prop]) target[actions[prop]]();
    } else if (prop === 'mute' || prop === 'unmute') {
      if (this.getAttribute('source') === 'vimeo') {
        target.setMuted(prop === 'mute');
      } else {
        target.muted = prop === 'mute';
      }
    } else {
      if (prop === 'play' && !this.hasAttribute('source')) {
        target.play().catch((error) => {
          if (error.name === 'NotAllowedError') {
            this.setAttribute('suspended', '');
            target.controls = true;
            const replacementImageSrc = target.previousElementSibling?.currentSrc;
            if (replacementImageSrc) {
              target.poster = replacementImageSrc;
            }
          }
        });
      } else {
        target[prop]();
      }
    }
  }
}
customElements.define('video-element', VideoElement);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure-list'),
    };

    this.listTemplate = this.elements.panel.querySelector('template');
    this.panelLoaded = !this.listTemplate;

    this.elements.panel.removeAttribute('hidden');
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    if (this.panelLoaded) this.bindOptions();
  }

  loadPanel() {
    if (this.panelLoaded || !this.listTemplate) return;

    this.elements.panel.appendChild(document.importNode(this.listTemplate.content, true));
    this.listTemplate.remove();
    this.listTemplate = null;
    this.panelLoaded = true;
    this.bindOptions();
  }

  bindOptions() {
    this.elements.panel.querySelectorAll('[data-disclosure-option]').forEach((item) => {
      item.addEventListener('click', this.onItemClick.bind(this));
    });
  }

  handleDropdownPos() {
    const offsetButton = this.elements.button.getBoundingClientRect().right;
    if (window.innerWidth - offsetButton < 220) {
      this.elements.button.nextElementSibling &&
        this.elements.button.nextElementSibling.classList.add('disclosure-list__right');
    }
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.removeAttribute('open');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.loadPanel();
    this.handleDropdownPos();
    this.elements.button.focus();
    this.toggleAttribute('open');
    this.elements.button.setAttribute(
      'aria-expanded',
      (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
    );
  }

  closeSelector(event) {
    const shouldClose =
      (event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON') ||
      (event.relatedTarget && !event.relatedTarget.classList.contains('disclosure-list__option'));
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel(shouldClose);
    }
  }
}
customElements.define('localization-form', LocalizationForm);

class GridList extends HTMLElement {
  constructor() {
    super();

    if (FoxTheme.config.motionReduced || FoxTheme.config.disableAnimations || this.hasAttribute('motion-reduced'))
      return;

    this.hideGridItems();
    FoxTheme.Motion.inView(this, this.showGridItems.bind(this), { margin: '0px 0px -50px 0px' });
  }

  get gridItems() {
    return this.querySelectorAll('.f-column');
  }

  get visibleGridItems() {
    return this.querySelectorAll('.f-column:not([style])');
  }

  // Faded, not visibility: hidden: the items stay in the Tab order, and the reveal can't take focus from one.
  hideGridItems() {
    FoxTheme.Motion.animate(
      this.gridItems,
      { transform: 'translateY(3.5rem)', opacity: 0 },
      { duration: 0 }
    );
  }

  showGridItems() {
    if (FoxTheme.config.disableAnimations) return;

    FoxTheme.Motion.animate(
      this.gridItems,
      { transform: ['translateY(3.5rem)', 'translateY(0)'], opacity: [0, 1] },
      {
        duration: 0.5,
        delay: FoxTheme.config.motionReduced || FoxTheme.config.disableAnimations ? 0 : FoxTheme.Motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }

  reShowVisibleGridItems() {
    if (FoxTheme.config.disableAnimations) return;

    FoxTheme.Motion.animate(
      this.visibleGridItems,
      { transform: ['translateY(3.5rem)', 'translateY(0)'], opacity: [0, 1] },
      {
        duration: 0.5,
        delay: FoxTheme.config.motionReduced || FoxTheme.config.disableAnimations ? 0 : FoxTheme.Motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }
}
customElements.define('grid-list', GridList);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.announcementItemsWrapper = this.querySelector('.swiper-wrapper');

    if (FoxTheme.config.disableAnimations || FoxTheme.config.motionReduced) {
      this.initializeCarousel();
    } else {
      FoxTheme.Motion.inView(this, this.initializeCarousel.bind(this), { margin: '200px 0px 200px 0px' });
    }
  }

  getNextSlideButton() {
    return this.querySelector('.swiper-button-next');
  }

  getPrevSlideButton() {
    return this.querySelector('.swiper-button-prev');
  }

  get getSlideItems() {
    return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.announcementItemsWrapper.children));
  }

  isAutoplayEnabled() {
    return this.hasAttribute('autoplay');
  }

  getAutoplaySpeed() {
    return this.hasAttribute('autoplay') ? parseInt(this.getAttribute('autoplay-speed')) * 1000 : 5000;
  }

  initializeCarousel() {
    if (this.getSlideItems.length > 1) {
      this.carousel = new FoxTheme.Carousel(
        this,
        {
          navigation: {
            nextEl: this.getNextSlideButton(),
            prevEl: this.getPrevSlideButton(),
          },
          loop: true,
          autoplay: this.isAutoplayEnabled() ? { delay: this.getAutoplaySpeed(), pauseOnMouseEnter: true } : false,
        },
        FoxTheme.Swiper.Autoplay
      );
      this.carousel && this.carousel.init();

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          this.carousel.slider.slideToLoop(this.getSlideItems.indexOf(event.target));
        });
      }
    }
  }
}
customElements.define('announcement-bar', AnnouncementBar);

class SelectElement extends HTMLElement {
  constructor() {
    super();

    FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });

    this.select = this.querySelector('select');

    this.select && this.select.addEventListener('change', this.handleSelectChange.bind(this));
  }

  init() {
    const style = window.getComputedStyle(this);
    const value = this.select.options[this.select.selectedIndex].text;

    const text = document.createElement('span');
    text.style.fontFamily = style.fontFamily;
    text.style.fontSize = style.fontSize;
    text.style.fontWeight = style.fontWeight;
    text.style.visibility = 'hidden';
    text.style.position = 'absolute';
    text.innerHTML = value;

    document.body.appendChild(text);
    const width = text.clientWidth;

    this.style.setProperty('--width', `${width}px`);
    text.remove();
  }

  handleSelectChange() {
    this.init();
  }
}
customElements.define('select-element', SelectElement);

// Adds several variants to the cart in one request. Not registered as an element:
// a subclass returns its items from getItems() and calls addToCart() from its button.
class MultiProductAddToCart extends HTMLElement {
  // [{ id, quantity, properties?, selling_plan? }]; a missing or invalid quantity counts as 1.
  getItems() {
    return [];
  }

  getSubmitElement() {
    return this.querySelector('[data-multi-add-submit]');
  }

  getMessageElement() {
    return this.querySelector('.product-form__error-message');
  }

  // Tag sent with the cartUpdate / cartError pubsub events.
  get source() {
    return 'multi-add';
  }

  // Cart page mode: true posts a native form like before (id and quantity only),
  // false adds by Ajax then goes to the cart page.
  get usesFormPost() {
    return false;
  }

  get isPageCart() {
    return document.body.classList.contains('cart-template') || FoxTheme.settings.cartType !== 'drawer';
  }

  onAddSuccess(response, cart) {}

  onAddError(response) {}

  // Drops empty ids and merges lines with the same variant, selling plan and properties.
  normalizeItems(items) {
    const lines = new Map();
    items.forEach((item) => {
      if (!item || !item.id) return;

      const quantity = Math.max(1, parseInt(item.quantity, 10) || 1);
      const key = JSON.stringify([String(item.id), String(item.selling_plan || ''), item.properties || null]);
      const line = lines.get(key);
      if (line) {
        line.quantity += quantity;
      } else {
        lines.set(key, { ...item, quantity });
      }
    });

    return [...lines.values()];
  }

  async addToCart(event) {
    event?.preventDefault();
    if (this.isLoading) return;

    const submitElement = this.getSubmitElement();
    if (submitElement?.disabled || submitElement?.getAttribute('aria-disabled') === 'true') return;

    const items = this.normalizeItems(this.getItems());
    if (!items.length) return;

    if (this.isPageCart && this.usesFormPost) {
      FoxTheme.utils.postLink(FoxTheme.routes.cart_add_url, { parameters: { items } });
      return;
    }

    this.lastClickedElement = event?.submitter || event?.currentTarget || submitElement;
    this.showMessage();
    this.setLoading(true);

    // shopify:cart:lines-update, one event for all items. Must be settled on every path below.
    const standardEvents = FoxTheme.StandardEvents;
    // A partial add (capped by stock) is reported as a warning, not as a decline
    const addedToCart = standardEvents?.addedToCartChecker(items.map((item) => item.id));
    const standardHandles = standardEvents?.dispatch(this, 'CartLinesUpdateEvent', {
      action: 'add',
      context: 'product',
      lines: items.map((item) => ({
        merchandiseId: standardEvents?.variantGid(item.id),
        quantity: item.quantity,
      })),
    });

    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );

    let redirecting = false;
    try {
      const response = await (
        await fetch(`${FoxTheme.routes.cart_add_url}`, {
          ...FoxTheme.utils.fetchConfig('javascript'),
          body: JSON.stringify({
            items,
            // The API renders at most 5 sections.
            sections: sections.slice(0, 5),
            sections_url: window.location.pathname,
          }),
        })
      ).json();

      if (response.status) {
        standardEvents?.resolveCart(standardHandles, {
          userErrors: [{ code: 'INVALID', message: standardEvents?.declinedMessage(response) }],
          isApplied: addedToCart,
        });
        await this.handleAddError(response, items);
        return;
      }

      if (this.isPageCart) {
        // Settle the event before leaving the page, waiting 1.5 s at most for the cart.js read it makes (the add
        // already succeeded). Without the library loaded there is nothing to settle.
        if (standardEvents && window.StandardEvents) {
          await Promise.race([
            standardEvents.resolveCart(standardHandles),
            new Promise((resolve) => setTimeout(resolve, 1500)),
          ]);
        }
        this.onAddSuccess(response, null);
        redirecting = true;
        // Back from the cart page can restore this page from the bfcache with the button still loading.
        window.addEventListener('pageshow', (pageEvent) => pageEvent.persisted && this.setLoading(false), {
          once: true,
        });
        window.location.href = FoxTheme.routes.cart_url;
        return;
      }

      const cart = await this.fetchCart();
      cart.sections = response.sections;

      standardEvents?.resolveCart(standardHandles, { ajaxCart: cart });
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: this.source, cart });
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: response } }));
      document.querySelector('cart-drawer')?.show(this.lastClickedElement);
      this.onAddSuccess(response, cart);
    } catch (error) {
      console.error(error);
      standardEvents?.rejectCart(standardHandles, this, error);
      this.showMessage(FoxTheme.cartStrings.error);
    } finally {
      if (!redirecting) this.setLoading(false);
    }
  }

  async handleAddError(response, items) {
    this.showMessage(response.description || response.message || FoxTheme.cartStrings.error);
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
      source: this.source,
      items,
      errors: response.errors || response.description,
      message: response.message,
    });
    document.dispatchEvent(
      new CustomEvent('product-ajax:error', {
        detail: {
          errorMessage: response.description,
        },
      })
    );
    this.onAddError(response);

    try {
      await this.refreshCart();
    } catch (error) {
      // Keep Shopify's message: a failed refresh must not replace it with the generic error.
      console.error(error);
    }
  }

  // After an error, so the cart shows whatever Shopify did add.
  async refreshCart() {
    if (!this.isPageCart && document.querySelector('cart-drawer')) {
      // The drawer re-renders itself and publishes cartUpdate.
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return;
    }

    const cart = await this.fetchCart();
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: this.source, cart });
  }

  async fetchCart() {
    return (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig('json', 'GET') })).json();
  }

  setLoading(isLoading) {
    this.isLoading = isLoading;

    const submitElement = this.getSubmitElement();
    if (!submitElement) return;

    submitElement.classList.toggle('btn--loading', isLoading);
    submitElement.toggleAttribute('disabled', isLoading);
  }

  showMessage(message = false) {
    const messageElement = this.getMessageElement();
    if (!messageElement) return;

    messageElement.hidden = !message;
    if (message) messageElement.textContent = message;
  }
}

class ProductBundleVariantSelector extends HTMLElement {
  constructor() {
    super();

    this.cssClasses = {
      soldOut: 'f-price--sold-out',
      onSale: 'f-price--on-sale',
      noCompare: 'f-price--no-compare',
    };

    this.priceElement = this.querySelector('.f-price');
    this.variantSelect = this.querySelector('select');

    this.variantSelect && this.variantSelect.addEventListener('change', this.handleVariantChange.bind(this));
  }

  handleVariantChange(event) {
    const variantSelect = event.target;
    const selectedVariant = variantSelect.options[variantSelect.selectedIndex];
    const compareAtPrice = parseInt(selectedVariant.dataset.compare_at_price || 0);
    const price = parseInt(selectedVariant.dataset.price || 0);
    const available = selectedVariant.dataset.available === 'true';
    const priceVaries = variantSelect.dataset.price_varies === 'true';
    const compareAtPriceVaries = variantSelect.dataset.compare_at_price_varies === 'true';

    // Remove classes
    this.priceElement.classList.remove(this.cssClasses.soldOut);
    this.priceElement.classList.remove(this.cssClasses.onSale);
    this.priceElement.classList.remove(this.cssClasses.noCompare);

    // Add classes
    if (!available) {
      this.priceElement.classList.add(this.cssClasses.soldOut);
    } else if (compareAtPrice > price && available) {
      this.priceElement.classList.add(this.cssClasses.onSale);
    }
    if (!priceVaries && compareAtPriceVaries) {
      this.priceElement.classList.add(this.cssClasses.noCompare);
    }

    // Change price
    const regularPriceElement = this.querySelector('.f-price__regular');
    regularPriceElement.querySelector('.f-price-item--regular').innerHTML = `${FoxTheme.Currency.formatMoney(
      price,
      FoxTheme.settings.moneyFormat
    )}`;

    const salePriceElement = this.querySelector('.f-price__sale');
    salePriceElement.querySelector('.f-price-item--regular').innerHTML = `<s>${FoxTheme.Currency.formatMoney(
      compareAtPrice,
      FoxTheme.settings.moneyFormat
    )}</s>`;
    salePriceElement.querySelector('.f-price-item--sale').innerHTML = `${FoxTheme.Currency.formatMoney(
      price,
      FoxTheme.settings.moneyFormat
    )}`;
  }
}
customElements.define('product-bundle-variant-selector', ProductBundleVariantSelector);

class ProductsBundle extends MultiProductAddToCart {
  constructor() {
    super();

    this.cssClasses = {
      hover: 'is-hover',
      active: 'is-active',
    };
  }

  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.addToCartButtonElement = this.querySelector('button');
    this.addToCartButtonElement &&
      this.addToCartButtonElement.addEventListener('click', this.handleButtonClick.bind(this), { signal });

    this.productBundleBlocks = this.querySelectorAll('[data-block-id]');
    if (FoxTheme.config.isTouch) {
      // No hover on touch: a tap highlights the matching block like a desktop hover.
      // A second tap on the already-active hotspot then follows its product link.
      this.productBundleBlocks.forEach((block) =>
        block.addEventListener('click', this.handleBlockTap.bind(this), { signal })
      );
    } else {
      this.productBundleBlocks.forEach((block) =>
        block.addEventListener('mouseenter', this.handleBlockHover.bind(this, 'enter'), { signal })
      );
      this.productBundleBlocks.forEach((block) =>
        block.addEventListener('mouseleave', this.handleBlockHover.bind(this, 'leave'), { signal })
      );
      this.querySelectorAll('a.product-bundle-hotspot').forEach((hotspot) => {
        hotspot.addEventListener('focusin', this.handleHotspotFocus.bind(this), { signal });
        hotspot.addEventListener('focusout', this.handleHotspotFocus.bind(this), { signal });
      });
    }
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  getItems() {
    return [...this.querySelectorAll('[name="id"]')].map((input) => ({ id: input.value, quantity: 1 }));
  }

  // /cart/add.js refuses the whole bundle when one product is sold out, but the page-cart form post adds
  // that product anyway: refuse it here, like the Ajax path does.
  addToCart(event) {
    const soldOutInput = this.isPageCart && this.querySelector('[name="id"]:disabled');
    if (!soldOutInput) return super.addToCart(event);

    event?.preventDefault();
    const title = soldOutInput.closest('.product-bundle-card')?.querySelector('.product-bundle-card__title-link');
    this.showMessage([title?.textContent.trim(), FoxTheme.variantStrings.soldOut].filter(Boolean).join(': '));
  }

  getSubmitElement() {
    return this.addToCartButtonElement;
  }

  get usesFormPost() {
    return true;
  }

  handleBlockTap(event) {
    const block = event.currentTarget;

    // Already highlighted: let the tap follow the hotspot's <a> link (cards have none).
    if (block.classList.contains(this.cssClasses.active)) return;

    // Otherwise treat the tap like a hover and highlight it (no navigation yet).
    if (block.tagName === 'A') event.preventDefault();
    this.classList.add(this.cssClasses.hover);
    this.toggleBlockActive(block, true);
  }

  handleBlockHover(type, event) {
    // A hotspot with keyboard focus stays highlighted when the pointer leaves.
    this.highlightBlock(
      type === 'enter' ? event.currentTarget : this.querySelector('a.product-bundle-hotspot:focus-visible')
    );
  }

  // :focus-visible leaves out the focus a mouse click gives the link.
  handleHotspotFocus(event) {
    if (event.type === 'focusout') {
      this.highlightBlock(this.querySelector('[data-block-id]:hover'));
    } else if (event.currentTarget.matches(':focus-visible')) {
      this.highlightBlock(event.currentTarget);
    }
  }

  highlightBlock(block) {
    this.classList.toggle(this.cssClasses.hover, Boolean(block));
    this.toggleBlockActive(block, Boolean(block));
  }

  toggleBlockActive(target, isActive) {
    this.productBundleBlocks.forEach((block) => {
      if (target) {
        if (block.dataset.blockId === target.dataset.blockId) {
          block.classList.add(this.cssClasses.active);
        } else {
          block.classList.remove(this.cssClasses.active);
        }
      } else {
        block.classList.remove(this.cssClasses.active);
      }
    });
  }

  // Kept so scripts that call or patch it keep working.
  handleButtonClick(event) {
    return this.addToCart(event);
  }
}
customElements.define('products-bundle', ProductsBundle);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    if (FoxTheme.config.hasLocalStorage) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = 'sleektheme:recently-viewed';
      const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');

      if (items.includes(productId)) {
        items.splice(items.indexOf(productId), 1);
      }

      items.unshift(productId);

      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 20)));
    }
  }
}
customElements.define('product-recently-viewed', ProductRecentlyViewed);

class MotionElement extends HTMLElement {
  constructor() {
    super();
    this.preInitialize();
  }

  connectedCallback() {
    if (FoxTheme.config.motionReduced || FoxTheme.config.disableAnimations) return;
    FoxTheme.Motion.inView(
      this,
      async () => {
        if (!this.isInstant && this.media) await FoxTheme.utils.imageReady(this.media);
        this.initialize();
      },
      { margin: '0px 0px -50px 0px' }
    );
  }

  get isHold() {
    return this.hasAttribute('hold');
  }

  get isInstant() {
    return this.hasAttribute('data-instantly');
  }

  get mediaElements() {
    return Array.from(this.querySelectorAll('img, iframe, svg'));
  }

  get animationType() {
    return this.dataset.motion || 'fade-up';
  }

  get animationDelay() {
    return parseInt(this.dataset.motionDelay || 0) / 1000;
  }

  preInitialize() {
    if (this.isHold || FoxTheme.config.motionReduced || FoxTheme.config.disableAnimations) return;
    switch (this.animationType) {
      case 'fade-in':
        FoxTheme.Motion.animate(this, { opacity: 0.01 }, { duration: 0 });
        break;

      case 'fade-up':
        FoxTheme.Motion.animate(this, { transform: 'translateY(2.5rem)', opacity: 0.01 }, { duration: 0 });
        break;

      case 'zoom-in':
        FoxTheme.Motion.animate(this, { transform: 'scale(0.8)' }, { duration: 0 });
        break;
      case 'zoom-in-lg':
        FoxTheme.Motion.animate(this, { transform: 'scale(0)' }, { duration: 0 });
        break;

      case 'zoom-out':
        FoxTheme.Motion.animate(this, { transform: 'scale(1.3)' }, { duration: 0 });
        break;

      case 'zoom-out-sm':
        FoxTheme.Motion.animate(this, { transform: 'scale(1.1)' }, { duration: 0 });
    }
  }

  async initialize() {
    if (this.isHold || this._animating || FoxTheme.config.motionReduced || FoxTheme.config.disableAnimations) return;
    this._animating = true;

    switch (this.animationType) {
      case 'fade-in':
        await FoxTheme.Motion.animate(
          this,
          { opacity: 1 },
          { duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;

      case 'fade-up':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;

      case 'zoom-in':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.3, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;

      case 'zoom-in-lg':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;

      case 'zoom-out':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;

      case 'zoom-out-sm':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;
    }

    this._animating = false;
    this.classList.add('is-animated');
  }

  async resetAnimation(duration) {
    if (FoxTheme.config.disableAnimations) return;
    // initialize() never animates back under reduced motion, so hide without moving; refreshAnimation() undoes it.
    if (FoxTheme.config.motionReduced) {
      this.style.opacity = 0;
      return;
    }

    switch (this.animationType) {
      case 'fade-in':
        await FoxTheme.Motion.animate(
          this,
          { opacity: 0 },
          {
            duration: duration ? duration : 1.5,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        ).finished;
        break;

      case 'fade-up':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'translateY(2.5rem)', opacity: 0 },
          {
            duration: duration ? duration : 0.5,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        ).finished;
        break;

      case 'zoom-in':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        ).finished;
        break;

      case 'zoom-in-lg':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        ).finished;
        break;

      case 'zoom-out':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0.16, 1, 0.3, 1],
          }
        ).finished;
        break;

      case 'zoom-out-sm':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0.16, 1, 0.3, 1],
          }
        ).finished;
        break;
    }
  }

  refreshAnimation() {
    if (FoxTheme.config.motionReduced) {
      this.style.opacity = '';
      return;
    }
    this._animating = false;
    this.removeAttribute('hold');
    this.preInitialize();
    setTimeout(() => {
      this.initialize();
    }, 50); // Delay a bit to make animation re init properly.
  }
}
customElements.define('motion-element', MotionElement);

class TabsComponent extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      tabHeader: '[role="tablist"]',
      tabPanels: ['[role="tabpanel"]'],
      tabNavs: ['[role="tab"]'],
      tabSelect: 'tab-selector',
    };
    this.domNodes = FoxTheme.utils.queryDomNodes(this.selectors, this);

    this.selectedIndex = 0;
    this.selectedTab = this.domNodes.tabPanels[this.selectedIndex];
    this.scrollToActiveTab = this.dataset.scrollToActiveTab === 'true';
    this.scrollOffset = 20;
    this.headerEl = document.querySelector('.header-section header[is="sticky-header"]');

    this.init();
    this.setActiveTab(0);

    this.tabChange = new CustomEvent('tabChange', {
      bubbles: true,
      detail: { selectedTab: this.selectedTab },
    });
  }

  connectedCallback() {
    this.setActiveTab(0);
  }

  init = () => {
    this.domNodes.tabNavs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
    });
    this.domNodes.tabHeader && this.domNodes.tabHeader.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.setAccessible();
  };

  static get observedAttributes() {
    return ['data-selected'];
  }

  get buttons() {
    return (this._buttons = this._buttons || Array.from(this.querySelectorAll('button[role="tab"]')));
  }

  getHeaderHeight() {
    let headerHeight = 0;

    if (this.headerEl) {
      const height = Math.round(this.headerEl.offsetHeight);
      if (this.headerEl.isAlwaysSticky) {
        headerHeight = height;
      } else {
        const isSticky = document.body.classList.contains(this.headerEl.classes.pinned);

        if (window.scrollY > this.offsetTop - this.scrollOffset) {
          headerHeight = height;
        }

        if (isSticky && window.scrollY >= this.offsetTop - this.scrollOffset - height) {
          headerHeight = height;
        }
      }
    }

    return headerHeight;
  }

  scrollToTop() {
    let offsetTop = this.offsetTop - this.scrollOffset - this.getHeaderHeight();
    window.scrollTo({ top: offsetTop, behavior: FoxTheme.config.disableAnimations ? 'auto' : 'smooth' });
  }

  onTabClick(evt) {
    if (evt.target.tagName === 'A' && evt.target.hasAttribute('href')) return;
    evt.preventDefault();
    const currentTab = evt.currentTarget;
    const index = currentTab ? Number(currentTab.dataset.index) : 0;
    this.setActiveTab(index);

    if (this.scrollToActiveTab) {
      this.scrollToTop();
    }
  }

  setActiveTab = (tabIndex) => {
    const { tabNavs, tabPanels, tabSelect } = this.domNodes;
    if (tabIndex !== -1) {
      const newHeader = tabNavs && tabNavs[tabIndex];
      const newTab = tabPanels && tabPanels[tabIndex];
      this.setAttribute('data-selected', tabIndex);

      tabNavs.forEach((nav) => {
        nav.setAttribute('aria-selected', false);
        // Only the selected tab is in the Tab order, so Tab goes on to its panel; arrows move between tabs.
        nav.setAttribute('tabindex', nav === newHeader ? 0 : -1);
      });

      newHeader && newHeader.setAttribute('aria-selected', true);

      this.selectedIndex = tabIndex;
      this.selectedTab = newTab;

      this.onTabChange();

      // After onTabChange, which may fill the panel. A panel needs a Tab stop only when nothing in it can take focus.
      tabPanels.forEach((panel) => panel.removeAttribute('tabindex'));
      if (newTab && !FoxTheme.a11y.getFocusableElements(newTab).length) {
        newTab.setAttribute('tabindex', 0);
      }

      this.dispatchEvent(
        new CustomEvent('tabChange', {
          bubbles: true,
          detail: { selectedIndex: tabIndex, selectedTab: newTab },
        })
      );

      if (tabSelect) {
        tabSelect.querySelector('select').value = tabIndex;
      }
    }
  };

  onTabChange() {}

  setAccessible() {
    const { tabNavs, tabPanels } = this.domNodes;
    tabNavs.forEach((tab, index) => {
      if (tab.id) tabPanels[index].setAttribute('aria-labelledby', tab.id);
      tab.setAttribute('aria-selected', index === 0);
      tab.setAttribute('data-index', index);
    });
    tabPanels.forEach((panel, index) => {
      if (panel.id) tabNavs[index].setAttribute('aria-controls', panel.id);
    });
  }

  handleKeyDown(e) {
    const { tabNavs } = this.domNodes;
    const index = tabNavs.indexOf(e.target);
    if (index === -1) return;

    let nextIndex;
    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (index + 1) % tabNavs.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (index - 1 + tabNavs.length) % tabNavs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = tabNavs.length - 1;
        break;
      default:
        return;
    }

    e.preventDefault();
    this.setActiveTab(nextIndex);
    tabNavs[nextIndex].focus();
  }

  getSelected() {
    return {
      index: this.selectedIndex,
      element: this.selectedTab,
    };
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-selected' && oldValue !== null && oldValue !== newValue) {
      const fromButton = this.buttons[parseInt(oldValue)];
      const toButton = this.buttons[parseInt(newValue)];
      this.transition(
        document.getElementById(fromButton.getAttribute('aria-controls')),
        document.getElementById(toButton.getAttribute('aria-controls'))
      );
    }
  }

  async transition(fromPanel, toPanel) {
    if (FoxTheme.config.disableAnimations) {
      fromPanel.hidden = true;
      toPanel.hidden = false;
      // After setActiveTab returns, so `tabChange` and onTabChange's content (ProductTabs) come first.
      queueMicrotask(() => this.dispatchTabShown(toPanel));
      return;
    }

    await FoxTheme.Motion.animate(
      fromPanel,
      { transform: ['translateY(0)', 'translateY(2rem)'], opacity: [1, 0] },
      { duration: 0.3 }
    ).finished;

    fromPanel.hidden = true;
    toPanel.hidden = false;
    this.dispatchTabShown(toPanel);

    FoxTheme.Motion.animate(
      toPanel,
      { transform: ['translateY(2rem)', 'translateY(0)'], opacity: [0, 1] },
      { duration: 0.3 }
    ).finished;

    toPanel.querySelector('grid-list') && toPanel.querySelector('grid-list').showGridItems();
  }

  // `tabChange` fires while the new panel is still hidden (the old one fades out first), so anything
  // that measures the panel (a carousel, a layout) listens for `tabShown`: the panel is in the layout.
  dispatchTabShown(panel) {
    this.dispatchEvent(
      new CustomEvent('tabShown', {
        bubbles: true,
        detail: { selectedIndex: Number(this.dataset.selected), selectedTab: panel },
      })
    );
  }
}
customElements.define('tabs-component', TabsComponent);

class ProductTabs extends TabsComponent {
  constructor() {
    super();
  }

  onTabChange() {
    const productsList = this.selectedTab.querySelector(`.products-list`);
    if (productsList) {
      return;
    }

    const template = this.selectedTab.querySelector(`template`);
    const tabContent = template.content.cloneNode(true).firstElementChild;
    this.selectedTab.appendChild(tabContent);
  }
}
customElements.define('product-tabs', ProductTabs);

class TabSelector extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.closest('tabs-component');

    this.querySelector('select').addEventListener('change', (e) => {
      this.tabs.setActiveTab(e.target.value);
    });
  }
}
customElements.define('tab-selector', TabSelector);

class Parallax extends HTMLElement {
  get parallax() {
    return this.dataset.parallax ? parseFloat(this.dataset.parallax) : false;
  }

  get parallaxDirection() {
    return this.dataset.parallaxDirection || 'vertical';
  }

  get parallaxMediaElements() {
    return Array.from(this.querySelectorAll('img, video, iframe, svg, video-element'));
  }

  connectedCallback() {
    if (this.shouldInitializeParallax()) {
      this.setupParallax();
    }
  }

  shouldInitializeParallax() {
    return !FoxTheme.config.motionReduced && this.parallax;
  }

  setupParallax() {
    const parallaxScale = 1 + this.parallax;
    const parallaxTranslate = (this.parallax * 100) / (1 + this.parallax);

    let parallaxTransformProperties = {};

    if (this.parallaxDirection === 'vertical') {
      parallaxTransformProperties = {
        transform: [
          `scale(${parallaxScale}) translateY(0)`,
          `scale(${parallaxScale}) translateY(${parallaxTranslate}%)`,
        ],
        transformOrigin: ['bottom', 'bottom'],
      };
    } else if (this.parallaxDirection === 'horizontal') {
      parallaxTransformProperties = {
        transform: [
          `scale(${parallaxScale}) translateX(0)`,
          `scale(${parallaxScale}) translateX(${parallaxTranslate}%)`,
        ],
        transformOrigin: ['right', 'right'],
      };
    } else {
      parallaxTransformProperties = {
        transform: [`scale(1)`, `scale(${parallaxScale})`],
        transformOrigin: ['center', 'center'],
      };
    }

    FoxTheme.Motion.scroll(
      FoxTheme.Motion.animate(this.parallaxMediaElements, parallaxTransformProperties, { easing: 'linear' }),
      {
        target: this,
        offset: ['start end', 'end start'],
      }
    );
  }
}
customElements.define('parallax-element', Parallax);

class ProductForm extends HTMLFormElement {
  constructor() {
    super();

    this.productIdInput = this.querySelector('[name=id]');
    this.productIdInput.disabled = false;
    this.addEventListener('submit', this.handleFormSubmit);
    this.addEventListener('click', this.handleDynamicCheckoutClick, { capture: true });
  }

  get cartDrawerElement() {
    return document.querySelector('cart-drawer');
  }

  get submitButtonElement() {
    return (this._submitButtonElement = this._submitButtonElement || this.querySelector('[type="submit"]'));
  }

  get isHideErrors() {
    return this.dataset.hideErrors === 'true';
  }

  // The dynamic checkout button (Buy now) sends the form on its own, so the browser never validates it: a required
  // line item property (a field outside the form, tied to it by its form attribute) would be skipped.
  // Only the unbranded button: the branded ones (Shop Pay, PayPal, Apple/Google Pay) live in cross-origin
  // iframes, so their clicks never reach this listener and can't be validated from here.
  handleDynamicCheckoutClick = (event) => {
    if (!event.target.closest?.('.shopify-payment-button__button--unbranded') || this.checkValidity()) return;

    event.preventDefault();
    event.stopPropagation();
    this.reportValidity();
  };

  handleFormSubmit = (event) => {
    if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType === 'page') return;

    event.preventDefault();
    if (this.submitButtonElement.hasAttribute('aria-disabled')) return;
    this.lastSubmittedElement = event.submitter || event.currentTarget;

    this.displayFormErrors();

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    this.formData = new FormData(this);
    this.formData.append('sections', sectionsToBundle);
    this.formData.append('sections_url', window.location.pathname);

    config.body = this.formData;

    this.submitButtonElement.setAttribute('aria-disabled', 'true');
    this.submitButtonElement.classList.add('btn--loading');

    this.handleFormSubmission(config);
  };

  displayFormErrors = (errorMessage = false) => {
    if (this.isHideErrors) return;

    this.formErrorMessage = this.formErrorMessage || this.querySelector('.product-form__error-message');
    if (!this.formErrorMessage) {
      if (errorMessage !== false) {
        alert(errorMessage);
      }
    } else {
      this.formErrorMessage.toggleAttribute('hidden', !errorMessage);
      this.formErrorMessage.innerText = errorMessage;
    }
  };

  handleFormSubmission = async (config) => {
    // A partial add (capped by stock) is reported as a warning, not as a decline
    const standardEvents = FoxTheme.StandardEvents;
    const addedToCart = standardEvents?.addedToCartChecker([this.formData.get('id')]);
    // Must be settled on every path below
    const standardHandles = standardEvents?.dispatch(this, 'CartLinesUpdateEvent', {
      action: 'add',
      context: 'product',
      lines: [
        {
          merchandiseId: standardEvents?.variantGid(this.formData.get('id')),
          quantity: Number(this.formData.get('quantity')) || 1,
        },
      ],
    });

    fetch(`${FoxTheme.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then(async (parsedState) => {
        if (parsedState.status) {
          this.handleCartError(parsedState);
          const cartJsonSub = await (
            await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig('json', 'GET') })
          ).json();

          standardEvents?.resolveCart(standardHandles, {
            ajaxCart: cartJsonSub,
            userErrors: [{ code: 'INVALID', message: standardEvents?.declinedMessage(parsedState) }],
            isApplied: addedToCart,
          });
          this.updateCartState(cartJsonSub);
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: {
                open: true,
              },
            })
          );
          return;
        }

        const cartJson = await (
          await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig('json', 'GET') })
        ).json();
        cartJson['sections'] = parsedState['sections'];

        standardEvents?.resolveCart(standardHandles, { ajaxCart: cartJson });
        this.updateCartState(cartJson);
        this.dispatchProductAddedEvent(parsedState);

        this.showCartDrawer();
      })
      .catch((error) => {
        console.log(error);
        standardEvents?.rejectCart(standardHandles, this, error);
      })
      .finally(() => {
        this.submitButtonElement.classList.remove('btn--loading');
        this.submitButtonElement.removeAttribute('aria-disabled');

        if (!this.hasError) {
          this.submitButtonElement.removeAttribute('aria-disabled');
        }
      });
  };

  handleCartError = (parsedState) => {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
      source: 'product-form',
      productVariantId: this.formData.get('id'),
      errors: parsedState.errors || parsedState.description,
      message: parsedState.message,
    });

    this.displayFormErrors(parsedState.description);
    document.dispatchEvent(
      new CustomEvent('product-ajax:error', {
        detail: {
          errorMessage: parsedState.description,
        },
      })
    );
    this.hasError = true;
  };

  updateCartState = (cartJson) => {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  };

  dispatchProductAddedEvent = (parsedState) => {
    document.dispatchEvent(
      new CustomEvent('product-ajax:added', {
        detail: {
          product: parsedState,
        },
      })
    );
  };

  showCartDrawer = () => {
    const quickViewModal = this.closest('quick-view-modal');
    if (quickViewModal) {
      if (this.cartDrawerElement && !this.cartDrawerElement.open) {
        document.body.addEventListener(
          quickViewModal.events.handleAfterHide,
          () => {
            setTimeout(() => {
              this.cartDrawerElement.show(this.lastSubmittedElement);
            });
          },
          { once: true }
        );
      }

      quickViewModal.hide(true);
    } else {
      this.cartDrawerElement && this.cartDrawerElement.show(this.lastSubmittedElement);
    }
  };
}
customElements.define('product-form', ProductForm, { extends: 'form' });

class HighlightText extends HTMLElement {
  constructor() {
    super();

    if (FoxTheme.config.disableAnimations || FoxTheme.config.motionReduced) {
      this.init();
    } else {
      FoxTheme.Motion.inView(this, this.init.bind(this));
    }
  }

  init() {
    this.classList.add('animate');
  }
}
customElements.define('highlight-text', HighlightText, { extends: 'em' });

class NewsletterForm extends HTMLFormElement {
  constructor() {
    super();

    this.selectors = {
      subscribedMessage: '[id*=Newsletter-error-subscribed]',
      modal: '[id*=NewsletterAlertModal-]',
    };

    this.init();
  }

  /**
   * Show message when user re-subscribe with exists email.
   */
  init() {
    const liveUrl = window.location.href;
    const result = liveUrl.includes('form_type=customer');
    const inputVal = this.querySelector('[id*="NewsletterForm"]').value.length;
    const modalEl = this.querySelector(this.selectors.modal);

    if (result && inputVal != 0) {
      const subscribedMessageEl = this.querySelector(this.selectors.subscribedMessage);
      subscribedMessageEl && subscribedMessageEl.classList.remove('hidden');

      if (this.canShowModal()) {
        modalEl && modalEl.show();
        window.isNewsletterModalShow = true;
      }
    }

    const alertEl = this.querySelector('.form-message--main');
    if (alertEl) {
      if (this.canShowModal()) {
        modalEl && modalEl.show();
        window.isNewsletterModalShow = true;
      }
    }
  }

  /**
   * Shopify renders the posted state on every customer form of the page, so only one modal may open.
   * The redirect's hash names the form that was submitted (the form tag's action); prefer that one
   * and fall back to the first form when the hash names none.
   */
  canShowModal() {
    if (window.isNewsletterModalShow) return false;

    const submittedId = decodeURIComponent(window.location.hash.slice(1));
    const submittedForm = submittedId && document.getElementById(submittedId);
    if (submittedForm && submittedForm.matches('form[is="newsletter-form"]')) return submittedForm === this;

    return true;
  }
}
customElements.define('newsletter-form', NewsletterForm, { extends: 'form' });

if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    connectedCallback() {
      this.promotion = this.querySelector('.promotion');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      // Theme settings can turn the animation off; the visitor's preference can change while the page is open.
      this.reducedMotion.addEventListener('change', this.sync.bind(this), { signal });
      window.addEventListener('resize', FoxTheme.utils.debounce(this.sync.bind(this), 200), { signal });
      this.addEventListener('mouseleave', this.resetScroll.bind(this), { signal });

      this.stopInView = FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }

    disconnectedCallback() {
      this.abortController.abort();
      this.stopInView?.();
      this.resizeObserver?.disconnect();
      this.viewObserver?.disconnect();
      this.isReady = false;
    }

    get isStatic() {
      return this.reducedMotion.matches || FoxTheme.config.disableAnimations;
    }

    get clones() {
      return Array.from(this.querySelectorAll(':scope > .promotion[data-clone]'));
    }

    init() {
      if (this.isReady) return;
      this.isReady = true;

      this.sync();

      // Lazy images change the strip's width once they load.
      this.resizeObserver = new ResizeObserver(FoxTheme.utils.debounce(this.sync.bind(this), 100));
      this.resizeObserver.observe(this.promotion);

      // pause when out of view
      this.viewObserver = new IntersectionObserver(
        (entries) => entries.forEach((entry) => (entry.isIntersecting ? this.scrollingPlay() : this.scrollingPause())),
        { rootMargin: '0px 0px 50px 0px' }
      );
      this.viewObserver.observe(this);
    }

    // A static strip only has to fill the row; a moving one needs a full extra row to loop into.
    sync() {
      if (!this.isReady) return;

      const isStatic = this.isStatic;
      const stripWidth = this.promotion.offsetWidth;
      const minCopies = isStatic ? 1 : 2;
      const targetWidth = window.innerWidth * minCopies;
      const copies = stripWidth > 0 ? Math.max(minCopies, Math.ceil(targetWidth / stripWidth)) : minCopies;

      const clones = this.clones;
      for (let index = clones.length; index < copies - 1; index++) {
        this.appendChild(this.createClone());
      }
      clones.slice(Math.max(copies - 1, 0)).forEach((clone) => clone.remove());

      this.classList.toggle('scrolling-promotion--static', isStatic);
      this.querySelectorAll(':scope > .promotion').forEach((promotion) => {
        promotion.classList.toggle('promotion--animated', !isStatic);
        promotion.classList.toggle('promotion--has-clones', copies > 1);
      });

      // Only the static strip stays scrollable for the keyboard: a moving one has no resting position to scroll.
      if (isStatic && this.scrollWidth > this.clientWidth) {
        this.tabIndex = 0;
      } else {
        this.removeAttribute('tabindex');
        this.resetScroll();
      }
    }

    // Copies are only there to fill the row: not read twice and not in the Tab order, but still clickable.
    createClone() {
      const clone = this.promotion.cloneNode(true);
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      FoxTheme.a11y.getFocusableElements(clone).forEach((element) => element.setAttribute('tabindex', '-1'));
      return clone;
    }

    // Scrolled while paused: back to the start, or the loop would show a gap at its end.
    resetScroll() {
      if (!this.isStatic) this.scrollLeft = 0;
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}

// A swipe row only scrolls at some widths, and then the keyboard must be able to scroll it too.
(() => {
  const syncScrollRegions = () => {
    const regions = Array.from(document.querySelectorAll('.swipe-mobile, .swipe-tablet, .media-with-collection__products'));
    // Measure every row before touching any, so one row's write doesn't force layout for the next read.
    const scrollable = regions.map((region) => {
      // Content can overflow a row that doesn't scroll at this width, so check that it scrolls too.
      const scrolls = ['auto', 'scroll'].includes(getComputedStyle(region).overflowX);
      return scrolls && region.scrollWidth > region.clientWidth;
    });
    regions.forEach((region, index) => {
      if (scrollable[index]) {
        region.tabIndex = 0;
      } else {
        region.removeAttribute('tabindex');
      }
    });
  };

  FoxTheme.DOMready(() => FoxTheme.utils.onceLaidOut(document.body, syncScrollRegions));
  window.addEventListener('resize', FoxTheme.utils.debounce(syncScrollRegions, 300));
  document.addEventListener('shopify:section:load', syncScrollRegions);
})();
